<section class="hero py-6 py-lg-6 text-white dark-overlay">
    <img src="/assets/img/beach-palms.jpg" alt="Popular Destinations" class="bg-image">
    <div class="container overlay-content">
        <h1 class="hero-heading">This Link Has Expired or it has already being used </h1>
    </div>
</section>